module.exports = "/images/img-2.jpg?3191a50b0064554acf8908275e6b5edc";